module.exports = __webpack_public_path__ + "static/media/Ventilator_.1358ff4c.png";